import _get from 'lodash/get'
import _map from 'lodash/map'
import _find from 'lodash/find'
import _assign from 'lodash/assign'
import _cloneDeep from 'lodash/cloneDeep'
import _compact from 'lodash/compact'
import _size from 'lodash/size'
import { USD, COP, GBP, CAD, MXN, NZD, ARS, AUD, EUR, LTM } from '../currency'

export const PLAN_FOURTEEN_DAY_FREE_TRIAL = 'G 14DMO TY'
export const PLAN_MONTHLY = 'G 1M HH'
export const PLAN_ANNUAL = 'G 1Y NB'
export const PLAN_FOURTEEN_DAY_NINETY_NINE_CENT = 'G 2WMO CB'
export const PLAN_THREE_MONTH = 'G 3MMO UM'
export const PLAN_LEGACY_MONTHLY = 'GTV SB ME 1M'
export const PLAN_LEGACY_ANNUAL = 'GTV SB ME DA NT'
export const PLAN_LIVE_ACCESS = 'GTV 1Y LIVE'
export const PLAN_DISCOUNTED_LIVE_ACCESS = 'GTV 1Y LIVE DFY'
export const PLAN_COMP = 'GTV CM 00 1M'
export const PLAN_BOGO = 'GAIA 2 MO'
export const PLAN_B2G2 = 'GAIA 4 MO'
export const PLAN_SEVEN_DAY_MONTHLY_FREE_TRIAL = 'G 7DMO TY'
export const PLAN_SEVEN_DAY_ANNUAL_FREE_TRIAL = 'G 7DF ANNUAL'
export const PLAN_DECLINE_303 = 'GTV DECLINE'
export const PLAN_SUMMIT_ANNUAL = 'G 1Y TS'
export const PLAN_SUMMIT_ANNUAL_2 = 'G 1Y TS2'
export const PLAN_SUMMIT_ANNUAL_3 = 'G 1Y TS3'
export const PLAN_SUMMIT_MONTHLY = 'G 1M TS'
export const PLAN_ONE_DOLLAR_THIRTY_DAYS_TO_MONTHLY = 'G 30DMO TY'
export const PLAN_ONE_MONTH_TRIAL_TO_ANNUAL = 'G 30DMO TYA'

export const PLAN_SEVEN_DAY_MONTHLY_FREE_TRIAL_N24 = 'G 7DMO N24'
export const PLAN_MONTHLY_N24 = 'G 1M N24'
export const PLAN_SEVEN_DAY_ANNUAL_FREE_TRIAL_N24 = 'G 7DFAN N24'
export const PLAN_ANNUAL_N24 = 'G 1Y N24'
export const PLAN_LIVE_ACCESS_N24 = 'G GP N24'

export const PLAN_MONTHLY_N26 = 'G 1M N26'
export const PLAN_ANNUAL_N26 = 'G 1Y N26'

export const PLAN_ANNUAL_F25S = 'G 1Y F25S'

export const PLAN_G_1M_ARP = 'G 1M ARP'
export const PLAN_G_1M_AIP = 'G 1M AIP'
export const PLAN_G_3M_N25 = 'G 3M N25'

// Yoga International Skus
export const PLAN_YI_ONE_WEEK_TRIAL_TO_MONTHLY_BASIC = 'YI 1W MO BASIC'
export const PLAN_YI_ONE_WEEK_TRIAL_TO_ANNUAL_BASIC = 'YI 1W YR BASIC'
export const PLAN_YI_MONTHLY_BASIC = 'YI MO BASIC'
export const PLAN_YI_ANNUAL_BASIC = 'YI YR BASIC'
export const PLAN_YI_ANNUAL_PREMIUM = 'YI YR PREMIUM'
export const PLAN_YI_MONTHLY_PREMIUM = 'YI MO PREMIUM'
export const PLAN_YI_ANNUAL_WINBACK = 'YI YR BASIC WB1'
export const PLAN_YI_THREE_MONTH_TO_MONTHLY_BASIC = 'YI 3MO MO BASIC'

export const PLAN_PROVIDER_ROKU = 'roku'
export const PLAN_PROVIDER_GOOGLE = 'google'
export const PLAN_PROVIDER_AMAZON = 'amazon'
export const PLAN_PROVIDER_ITUNES = 'itunes'
export const PLAN_PROVIDER_ZUORA = 'zuora'
export const PLAN_PROVIDER_PAYPAL = 'paypal'
export const PLAN_PROVIDER_MYO_PAYPAL = 'myo_paypal'

export const PLAN_PROVIDER_ID_ZUORA = '1'
export const PLAN_PROVIDER_ID_ITUNES = '2'
export const PLAN_PROVIDER_ID_ROKU = '3'
export const PLAN_PROVIDER_ID_GOOGLE = '4'
export const PLAN_PROVIDER_ID_AMAZON = '5'
export const PLAN_PROVIDER_ID_PAYPAL = '6'
export const PLAN_PROVIDER_ID_MYO_PAYPAL = '7'

export const PLAN_PRODUCT_MONTHLY = 'Monthly'
export const PLAN_PRODUCT_ANNUAL = 'Annual'
export const PLAN_PRODUCT_GAIA_PLUS = 'Gaia+'
export const PLAN_PRODUCT_YI_BASIC = 'YI Basic'
export const PLAN_PRODUCT_YI_PREMIUM = 'YI Premium'

export const PLAN_PRODUCT_ID_MONTHLY = '1'
export const PLAN_PRODUCT_ID_ANNUAL = '2'
export const PLAN_PRODUCT_ID_GAIA_PLUS = '3'
export const PLAN_PRODUCT_ID_YI_BASIC = '4'
export const PLAN_PRODUCT_ID_YI_PREMIUM = '5'

export const PLAN_PROVIDER_PRODUCT_TYPE_RECURRING = 'Recurring'
export const PLAN_PROVIDER_PRODUCT_TYPE_COURSE = 'Course'
export const PLAN_PROVIDER_PRODUCT_TYPE_GIFT = 'Gift'

export const PLAN_PROVIDER_STAKEHOLDER_PRODUCT = 'product'
export const PLAN_PROVIDER_STAKEHOLDER_MARKETING = 'marketing'

export const PLAN_TERM_LENGTH_DAY = 'day'
export const PLAN_TERM_LENGTH_WEEK = 'week'
export const PLAN_TERM_LENGTH_MONTH = 'month'
export const PLAN_TERM_LENGTH_YEAR = 'year'

export const PLAN_PROVIDER_PRODUCT_TEXT_HEADING = 'heading'
export const PLAN_PROVIDER_PRODUCT_TEXT_TITLE = 'title'
export const PLAN_PROVIDER_PRODUCT_TEXT_NAME = 'name'
export const PLAN_PROVIDER_PRODUCT_TEXT_DURATION = 'duration'
export const PLAN_PROVIDER_PRODUCT_TEXT_BILLING_PERIOD = 'billingPeriod'
export const PLAN_PROVIDER_PRODUCT_TEXT_BILLING_SCHEDULE = 'billingSchedule'
export const PLAN_PROVIDER_PRODUCT_TEXT_BILLING_PERIOD_ABBREVIATION = 'billingPeriodAbbreviation'
export const PLAN_PROVIDER_PRODUCT_TEXT_SHORT_DETAILS = 'shortDetails'
export const PLAN_PROVIDER_PRODUCT_TEXT_PROMO_VALUE_1 = 'promoValue1'
export const PLAN_PROVIDER_PRODUCT_TEXT_PROMO_VALUE_2 = 'promoValue2'

/** Maximum length for promo value static text (displayed in checkout). */
export const PLAN_PROVIDER_PRODUCT_TEXT_PROMO_VALUE_MAX_LENGTH = 80

export const PLAN_BONUS_PROVIDER_GAIA = 'GAIA_BONUS'

export const PLAN_CHANGE_LOG_ENTITY_TEXT = 'Text'
export const PLAN_CHANGE_LOG_ENTITY_PRICE = 'Price'
export const PLAN_CHANGE_LOG_ENTITY_PLAN = 'Plan'
export const PLAN_CHANGE_LOG_ENTITY_BONUS = 'Bonus'
export const PLAN_CHANGE_LOG_ENTITY_BONUS_CAMPAIGN = 'BonusCampaign'
export const PLAN_CHANGE_LOG_ENTITY_BULK_DISCOUNT = 'BulkDiscount'
export const PLAN_CHANGE_LOG_ENTITY_ELIGIBILITY_RULE = 'EligibilityRule'
export const PLAN_CHANGE_LOG_ENTITY_DISCOUNT = 'Discount'

export const PLAN_CHANGE_LOG_ACTION_CREATE = 'Create'
export const PLAN_CHANGE_LOG_ACTION_UPDATE = 'Update'
export const PLAN_CHANGE_LOG_ACTION_DELETE = 'Delete'

export function getAllProviderTypes () {
  return [
    PLAN_PROVIDER_ROKU,
    PLAN_PROVIDER_GOOGLE,
    PLAN_PROVIDER_AMAZON,
    PLAN_PROVIDER_ITUNES,
    PLAN_PROVIDER_ZUORA,
    PLAN_PROVIDER_PAYPAL,
    PLAN_PROVIDER_MYO_PAYPAL,
  ]
}

export function getAllProductTypes () {
  return [
    PLAN_PRODUCT_MONTHLY,
    PLAN_PRODUCT_ANNUAL,
    PLAN_PRODUCT_GAIA_PLUS,
    PLAN_PRODUCT_YI_BASIC,
    PLAN_PRODUCT_YI_PREMIUM,
  ]
}

export function getAllProviderProductTypes () {
  return [
    PLAN_PROVIDER_PRODUCT_TYPE_RECURRING,
    PLAN_PROVIDER_PRODUCT_TYPE_COURSE,
    PLAN_PROVIDER_PRODUCT_TYPE_GIFT,
  ]
}

export function getAllStakeholderTypes () {
  return [PLAN_PROVIDER_STAKEHOLDER_PRODUCT, PLAN_PROVIDER_STAKEHOLDER_MARKETING]
}

export const PLAN_LIST_SCHEMA = {
  id: null,
  sku: null,
  provider: null,
  description: null,
  type: null,
  trialLength: null,
  bonuses: null,
  grids: null,
  enabled: null,
  createdAt: null,
}

export const PLAN_PRICE_SCHEMA = {
  id: null,
  sku: null,
  provider: null,
  description: null,
  createdAt: null,
  usd: null,
  eur: null,
  gbp: null,
  cad: null,
  aud: null,
  mxn: null,
  cop: null,
  ars: null,
  nzd: null,
  ltm: null,
}

export const BONUS_LIST_SCHEMA = {
  id: null,
  ecommerceSku: null,
  title: null,
  contentTitle: null,
  createdAt: null,
  doNotEntitle: null,
  productReferences: [],
}

export const BONUS_CAMPAIGN_LIST_SCHEMA = {
  id: null,
  planSku: null,
  planStatus: null,
  ecommerceSku: null,
  startDate: null,
  endDate: null,
  bonusStatus: null,
}

export const PLAN_GRID_SCHEMA = {
  id: null,
  variantName: null,
  plans: null,
  enabled: null,
  createdAt: null,
}

export const PLAN_CHANGE_LOG_SCHEMA = {
  id: null,
  username: null,
  changeType: null,
  entityName: null,
  previousValues: null,
  newValues: null,
  createdAt: null,
}

export const PLAN_CHANGE_LOG_LIST_SCHEMA = {
  id: null,
  username: null,
  changeType: null,
  entityName: null,
  sku: null,
  discountCode: null,
  providerName: null,
  productName: null,
  previousValues: null,
  newValues: null,
  createdAt: null,
}

/**
 * Formats plan list data into a grid-friendly structure
 * @param {Object} data - The raw plan data containing billing provider products
 * @param {Object} data.planList - The list of plans
 * @param {Array} data.planList.billingProviderProducts - Array of billing provider products
 * @returns {Array} Array of formatted plan rows matching PLAN_LIST_SCHEMA structure
 */
export function formatPlanListDataGridRows (data) {
  if (!data) {
    return []
  }

  const dataList = _get(data, ['planList', 'billingProviderProducts'], []) || []
  const rowsData = _map(dataList, (p) =>
    _assign(_cloneDeep(PLAN_LIST_SCHEMA), {
      id: _get(p, 'id'),
      sku: _get(p, 'sku'),
      provider: _get(p, ['billingProvider', 'name']),
      description: _get(p, 'description'),
      type: _get(p, ['billingProduct', 'name']),
      trialLength: !!(_get(p, 'trialLength') || _get(p, 'trialTermType')),
      primaryStakeholder: _get(p, 'primaryStakeholder'),
      enabled: _get(p, 'enabled'),
      createdAt: _get(p, 'createdAt'),
      updatedAt: _get(p, 'updatedAt'),
    }),
  )

  return rowsData
}

export function formatBonusListDataGridRows (data) {
  if (!data) {
    return []
  }

  const dataList = _get(data, ['ecommerceSkuMappingsList', 'ecommerceSkuMappings'], []) || []
  const rowsData = _map(dataList, (p) =>
    _assign(_cloneDeep(BONUS_LIST_SCHEMA), {
      id: _get(p, 'ecommerceSku'), // required by DataGridPro
      ecommerceSku: _get(p, 'ecommerceSku'),
      title: _get(p, 'title'),
      contentTitle: _get(p, ['contentProvider', 'content', 'title']),
      createdAt: _get(p, 'createdAt'),
      updatedAt: _get(p, 'updatedAt'),
      editProviderContent: _get(p, ['contentProvider', 'content', 'id']),
      enabled: _get(p, 'enabled'),
      doNotEntitle: _get(p, 'doNotEntitle'),
      productReferences: _get(p, ['contentProvider', 'content', 'contentReferencesTo'], []),
    }),
  )

  return rowsData
}

export function formatBonusCampaignListDataGridRows (data) {
  if (!data) {
    return []
  }

  const dataList =
    _get(
      data,
      ['ecommerceSkuMappingBonusEligibilitiesList', 'ecommerceSkuMappingBonusEligibilities'],
      [],
    ) || []
  const rowsData = _map(dataList, (p) =>
    _assign(_cloneDeep(BONUS_CAMPAIGN_LIST_SCHEMA), {
      id: _get(p, 'id'),
      planSku: _get(p, 'planSku'),
      planStatus: _get(p, ['billingProviderProduct', 'enabled']) ? 'enabled' : 'disabled',
      ecommerceSku: _get(p, 'ecommerceSku'),
      startDate: _get(p, 'startDate'),
      endDate: _get(p, 'endDate'),
      bonusStatus: _get(p, ['ecommerceSkuMapping', 'enabled']) ? 'enabled' : 'disabled',
    }),
  )

  return rowsData
}

/**
 * Formats a price object into a string with currency symbol and amount
 * @param {Object} priceData - The price data object containing price and currency symbol
 * @param {Number} priceData.price - The numerical price value
 * @param {String} priceData.currencySymbol - The currency symbol (e.g. '$', '£', '€')
 * @returns {String|null} Formatted price string (e.g. "$9.99") or null if price data is invalid
 */
export function formatPrice (priceData) {
  const amount = _get(priceData, 'price')
  const currencySymbol = _get(priceData, 'currencySymbol')

  if (amount === undefined || amount === null || !currencySymbol) {
    return null
  }

  if (currencySymbol === '€') {
    return `${amount} ${currencySymbol}`
  }

  return `${currencySymbol}${amount}`
}

/**
 * Formats plan price data into a grid-friendly structure with prices in multiple currencies
 * @param {Object} data - The raw plan data containing billing provider products
 * @param {Object} data.planList - The list of plans
 * @param {Array} data.planList.billingProviderProducts - Array of billing provider products with their prices
 * @param {Array} data.planList.billingProviderProducts[].billingProviderProductPrices - Array of prices for different currencies
 * @returns {Array} Array of formatted plan price rows matching PLAN_PRICE_SCHEMA structure
 */
export function formatPlanPriceDataGridRows (data) {
  if (!data) {
    return []
  }

  const dataList = _get(data, ['planList', 'billingProviderProducts'], []) || []
  const rowsData = _map(dataList, (p) => {
    const usd =
      _find(_get(p, 'billingProviderProductPrices'), (price) => _get(price, 'currency') === USD) ||
      {}
    const eur =
      _find(_get(p, 'billingProviderProductPrices'), (price) => _get(price, 'currency') === EUR) ||
      {}
    const gbp =
      _find(_get(p, 'billingProviderProductPrices'), (price) => _get(price, 'currency') === GBP) ||
      {}
    const cad =
      _find(_get(p, 'billingProviderProductPrices'), (price) => _get(price, 'currency') === CAD) ||
      {}
    const aud =
      _find(_get(p, 'billingProviderProductPrices'), (price) => _get(price, 'currency') === AUD) ||
      {}
    const mxn =
      _find(_get(p, 'billingProviderProductPrices'), (price) => _get(price, 'currency') === MXN) ||
      {}
    const cop =
      _find(_get(p, 'billingProviderProductPrices'), (price) => _get(price, 'currency') === COP) ||
      {}
    const ars =
      _find(_get(p, 'billingProviderProductPrices'), (price) => _get(price, 'currency') === ARS) ||
      {}
    const nzd =
      _find(_get(p, 'billingProviderProductPrices'), (price) => _get(price, 'currency') === NZD) ||
      {}
    const ltm =
      _find(_get(p, 'billingProviderProductPrices'), (price) => _get(price, 'currency') === LTM) ||
      {}
    return _assign(_cloneDeep(PLAN_PRICE_SCHEMA), {
      id: _get(p, 'id'),
      sku: _get(p, 'sku'),
      provider: _get(p, ['billingProvider', 'name']),
      description: _get(p, 'description'),
      usd: formatPrice(usd),
      eur: formatPrice(eur),
      gbp: formatPrice(gbp),
      cad: formatPrice(cad),
      aud: formatPrice(aud),
      mxn: formatPrice(mxn),
      cop: formatPrice(cop),
      ars: formatPrice(ars),
      nzd: formatPrice(nzd),
      ltm: formatPrice(ltm),
      createdAt: _get(p, 'createdAt'),
      updatedAt: _get(p, 'updatedAt'),
    })
  })

  return rowsData
}

/**
 * Formats plan grid list plans into a string
 * @param {Object} data - The raw plan grid list data
 * @param {Object} data.newMemberBillingProviderProductId1 - The new member billing provider product ID 1
 * @param {Object} data.newMemberBillingProviderProductId2 - The new member billing provider product ID 2
 * @param {Object} data.newMemberBillingProviderProductId3 - The new member billing provider product ID 3
 * @param {Object} data.newMemberBillingProviderProductId4 - The new member billing provider product ID 4 (hidden)
 * @param {Object} data.existingMemberBillingProviderProductId1 - The existing member billing provider product ID 1
 * @param {Object} data.existingMemberBillingProviderProductId2 - The existing member billing provider product ID 2
 * @param {Object} data.existingMemberBillingProviderProductId3 - The existing member billing provider product ID 3
 * @param {Object} data.existingMemberBillingProviderProductId4 - The existing member billing provider product ID 4 (hidden)
 * @returns {String} The formatted plan grid list plans string
 */
function formatPlanGridListPlans (data) {
  if (!data) {
    return null
  }

  let plans = null
  const newMemberPlans = _size(
    _compact(
      [].concat(
        _get(data, 'newMemberBillingProviderProductId1'),
        _get(data, 'newMemberBillingProviderProductId2'),
        _get(data, 'newMemberBillingProviderProductId3'),
        // _get(data, 'newMemberBillingProviderProductId4'),
      ),
    ),
  )
  const existingMemberPlans = _size(
    _compact(
      [].concat(
        _get(data, 'existingMemberBillingProviderProductId1'),
        _get(data, 'existingMemberBillingProviderProductId2'),
        _get(data, 'existingMemberBillingProviderProductId3'),
        // _get(data, 'existingMemberBillingProviderProductId4'),
      ),
    ),
  )

  if (newMemberPlans && existingMemberPlans) {
    plans = `${newMemberPlans}+${existingMemberPlans}`
  } else if (newMemberPlans) {
    plans = newMemberPlans
  } else if (existingMemberPlans) {
    plans = existingMemberPlans
  }

  return plans
}

/**
 * Formats plan grid data into a grid-friendly structure
 * @param {Object} data - The raw plan grid data
 * @param {Object} data.billingPlanGridList - The list of plan grids
 * @param {Array} data.billingPlanGridList.billingPlanGrids - Array of billing plan grids
 * @returns {Array} Array of formatted plan grid rows matching PLAN_GRID_SCHEMA structure
 */
export function formatPlanGridDataGridRows (data) {
  if (!data) {
    return []
  }

  const dataList = _get(data, ['billingPlanGridList', 'billingPlanGrids'], []) || []
  const rowsData = _map(dataList, (p) =>
    _assign(_cloneDeep(PLAN_GRID_SCHEMA), {
      id: _get(p, 'id'),
      variantName: _get(p, 'variantName'),
      defaultPageGrid: _get(p, 'defaultPageGrid'),
      page: _get(p, 'page'),
      plans: formatPlanGridListPlans(p),
      enabled: _get(p, 'enabled'),
      createdAt: _get(p, 'createdAt'),
    }),
  )

  return rowsData
}

/**
 * Formats plan change log data into a grid-friendly structure
 * @param {Object} data - The raw plan change log data
 * @param {Object} data.changeLog - The change log data
 * @param {Array} data.changeLog.billingProductChangeLogs - Array of billing product change logs
 * @returns {Array} Array of formatted plan change log rows matching PLAN_CHANGE_LOG_SCHEMA structure
 */
export function formatPlanChangeLogDataGridRows (data) {
  if (!data) {
    return []
  }

  const rowsData = _map(_get(data, 'changeLog.billingProductChangeLogs', []), (p) =>
    _assign(_cloneDeep(PLAN_CHANGE_LOG_SCHEMA), {
      id: _get(p, 'id'),
      username: _get(p, 'username'),
      changeType: _get(p, 'changeType'),
      entityName: _get(p, 'entityName'),
      previousValues: _get(p, 'previousValues'),
      newValues: _get(p, 'newValues'),
      createdAt: _get(p, 'createdAt'),
    }),
  )

  return rowsData
}

/**
 * Formats plan change log data into a grid-friendly structure
 * @param {Object} data - The raw plan change log data
 * @param {Object} data.changeLog - The change log data
 * @param {Array} data.changeLog.billingProductChangeLogs - Array of billing product change logs
 * @returns {Array} Array of formatted plan change log rows matching PLAN_CHANGE_LOG_SCHEMA structure
 */
export function formatPlanChangeLogListDataGridRows (data) {
  if (!data) {
    return []
  }

  const rowsData = _map(_get(data, 'changeLog.billingProductChangeLogs', []), (p) =>
    _assign(_cloneDeep(PLAN_CHANGE_LOG_LIST_SCHEMA), {
      id: _get(p, 'id'),
      username: _get(p, 'username'),
      changeType: _get(p, 'changeType'),
      entityName: _get(p, 'entityName'),
      sku: _get(p, 'sku'),
      discountCode: _get(p, 'discountCode'),
      providerName: _get(p, 'providerName'),
      productName: _get(p, 'productName'),
      previousValues: _get(p, 'previousValues'),
      newValues: _get(p, 'newValues'),
      createdAt: _get(p, 'createdAt'),
    }),
  )

  return rowsData
}
